<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <option-menu class="no-bg no-border">
          <div class="content-title-wrap">
            <div class="main-content-title">Consultant</div>
            <div class="searchbox">
              <label for="consultantFilter">
                <i
                  v-if="!filterTxt"
                  class="material-icons-outlined align-middle"
                  >search</i
                >
                <i
                  v-else
                  @click="onQuickFilterChanged"
                  class="material-icons-outlined align-middle"
                  >clear</i
                >
              </label>
              <input
                id="consultantFilter"
                type="text"
                @keyup="onQuickFilterChanged"
                :value="filterTxt"
                placeholder="Type text to filter..."
              />
            </div>
            <div class="main-content-menu">
              <button
                class="btn"
                href="javascript:void(0);"
                @click="resetFilter"
                title="RESET FILTER"
              >
                <i class="material-icons-outlined align-middle"
                  >settings_backup_restore</i
                >
                RESET FILTER
              </button>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="addConsultant"
                :class="{ active: editOpen == 1 }"
                title="ADD CONSULTANT"
              >
                <i class="material-icons-outlined align-middle"
                  >add_circle_outline</i
                >
                ADD CONSULTANT
              </button>
            </div>
          </div>
        </option-menu>
        <div class="main-bg p-0">
          <ag-grid-vue
            style="width: 100%; height: calc(100vh - 200px)"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            :rowData="rowData"
            :detailCellRendererParams="detailCellRendererParams"
            :masterDetail="true"
            @filterChanged="onFilterChanged($event)"
            @rowDataChanged="onRowDataChanged"
          ></ag-grid-vue>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelConsultant
            v-if="editOpen == 1"
            :propsData="propsData"
            :submitLoading="addConsultantSubmitLoading"
            @buttonClick="pannelButtonClick"
          ></PanelConsultant>
          <PanelConsultant
            v-if="editOpen == 2"
            :propsData="propsData"
            :submitLoading="addConsultantSubmitLoading"
            @buttonClick="pannelButtonClick"
          ></PanelConsultant>
          <PanelUpload
            v-if="editOpen == 3"
            :propsData="uploadProps"
            @closePanel="closeEditPannel"
          />
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import * as utils from "@/utils/utils";
import * as constant from "@/constant/constant";
import { httpGet } from "@/http/http";
import PanelConsultant from "@/components/admin/consultantAdmin/PanelConsultant.vue";
import GridDropdownMenu from "@/components/admin/consultantAdmin/GridDropdownMenu.vue";
import GridIsActive from "@/components/public/GridIsActive.vue";
import GridAmount from "@/components/public/GridAmount.vue";
import GridResume from "@/components/admin/consultantAdmin/GridResume.vue";
import GridLinkedin from "@/components/admin/consultantAdmin/GridLinkedin.vue";
import PanelUpload from "@/components/admin/consultantAdmin/PanelUpload.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      filterTxt: null,
      gridOptions: null,
      columnDefs: null,
      rowData: null,
      detailCellRendererParams: null,
      consultants: null,
      applies: null,
      editOpen: false,
      propsData: null,
      dd: {
        index: null,
        el: null,
        isOpen: false,
      },
      addConsultantSubmitLoading: false,
      filterMode: null,
      filterModeLoad: false,
      enableSetLocal: false,
      uploadProps: null,
    };
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    consultants() {
      this.updateRowData();
    },
    applies() {
      // console.log(this.applies);
      this.updateRowData();
    },
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    GridDropdownMenu,
    PanelConsultant,
    GridIsActive,
    GridAmount,
    GridResume,
    GridLinkedin,
    PanelUpload,
  },
  beforeMount() {
    this.initColumnDefs();
    this.bindData();
    this.loadFilterMode();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  beforeDestroy() {
    this.$EventBus.$off("globalClick");
  },
  methods: {
    onRowDataChanged: function () {
      this.setFilterMode();
    },
    onFilterChanged: function () {
      if (this.filterModeLoad && this.enableSetLocal) {
        const filterMode = this.gridOptions.api.getFilterModel();
        const jsonFilterMode = JSON.stringify(filterMode);
        this.filterMode = filterMode;
        window.localStorage.setItem(
          "consultant_admin_filter_mode",
          jsonFilterMode
        );
      }
    },
    loadFilterMode: function () {
      const filterMode = window.localStorage.getItem(
        "consultant_admin_filter_mode"
      );
      this.filterMode = JSON.parse(filterMode);
      this.filterModeLoad = true;
    },
    setFilterMode: function () {
      if (this.filterMode) {
        for (const col in this.filterMode) {
          const filterInstance = this.gridOptions.api.getFilterInstance(col);
          if (filterInstance) {
            const values = this.filterMode[col].values;
            filterInstance.selectNothing();
            for (const i in values) {
              filterInstance.selectValue(values[i]);
            }
            filterInstance.applyModel();
          }
        }
      }
      this.gridOptions.api.onFilterChanged();
    },
    bindData: function () {
      this.$bind("consultants", db.collection("consultants"));
      this.$bind("applies", db.collection("applies"));
    },
    initColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: true,
        enableCellTextSelection: true,
      };
      this.columnDefs = [
        {
          headerName: "EMAIL",
          field: "email",
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerName: "CREATED",
          field: "created",
          comparator: utils.dateComparator,
          sortingOrder: ["desc"],
          sort: { direction: "desc", priority: 0 },
        },
        { headerName: "NAME", field: "name" },
        {
          headerName: "RATE",
          field: "rate",
          width: 100,
          cellRendererFramework: "GridAmount",
        },
        {
          headerName: "METRO",
          field: "metro",
          width: 120,
          cellClass: "word-wrap",
        },
        { headerName: "WORK TYPE", field: "workType", width: 120 },
        {
          headerName: "TECH LEVEL",
          field: "techLevel",
          width: 120,
          cellClass: "word-wrap",
        },
        { headerName: "BIO", field: "bio", width: 250, cellClass: "word-wrap" },
        {
          headerName: "APPLICATION",
          field: "application",
          width: 100,
        },
        {
          headerName: "APPLICATION STATUS",
          field: "applicationStatus",
          width: 100,
        },
        {
          headerName: "IS ACTIVE",
          field: "isActive",
          width: 100,
          cellRendererFramework: "GridIsActive",
        },
        {
          headerName: "PAYMENT ACTIVE",
          field: "paymentActive",
          width: 100,
          cellRendererFramework: "GridIsActive",
        },
        { headerName: "SLACK ID", field: "slackId", width: 120 },
        { headerName: "VERIFIED", filed: "verified", width: 100 },
        { headerName: "VACCINATION", filed: "vaccination", width: 100 },
        {
          headerName: "ACTIONS",
          field: "actions",
          width: 180,
          cellClass: "overflow-visible",
          cellRendererFramework: "GridDropdownMenu",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
      this.detailCellRendererParams = {
        detailGridOptions: {
          columnDefs: [
            {
              headerName: "RESUME",
              field: "resume",
              cellRendererFramework: "GridResume",
            },
            {
              headerName: "WORK TYPE",
              field: "work",
            },
            {
              headerName: "LINKEDIN",
              field: "linkedin",
              cellRendererFramework: "GridLinkedin",
            },
            {
              headerName: "SCORE",
              field: "score",
            },
            { headerName: "METRO", field: "metro" },
            { headerName: "IS RELOCATION", field: "is_relocation" },
          ],
          enableCellTextSelection: true,
          onFirstDataRendered(params) {
            params.api.sizeColumnsToFit();
          },
        },
        getDetailRowData: (params) => {
          params.successCallback(params.data.callRecords);
        },
      };
    },
    onQuickFilterChanged: function (event) {
      this.filterTxt = event.target.value;
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    getApply: function (applyId) {
      if (this.applies) {
        for (const i in this.applies) {
          if (this.applies[i].id == applyId) {
            return this.applies[i];
          }
        }
      } else {
        return null;
      }
    },
    updateRowData: function () {
      const consultantArray = [];
      this.consultants.forEach((item, index) => {
        let apply = null;
        if (item.apply) {
          apply = this.getApply(item.apply);
        }
        consultantArray.push({
          index: index,
          id: item.id,
          email: item.email ? item.email : null,
          name: item.name ? item.name : null,
          slackId: item.slack_id ? item.slack_id : null,
          bio: item.bio ? item.bio : null,
          metro: item.metro ? item.metro : null,
          workType: item.work_type ? item.work_type : null,
          techLevel: item.tech_level ? item.tech_level : null,
          rate: item.rate ? item.rate : null,
          applicationStatus: item.application_status
            ? item.application_status
            : null,
          isActive: item.is_active ? true : false,
          application: apply ? true : false,
          ddOpen: false,
          callRecords: apply ? [apply] : null,
          created: item.created
            ? utils.dateformat(item.created, "MM/DD/YYYY HH:mm A")
            : null,
          rateType: item.rate_type ? item.rate_type : null,
          address: item.address,
          phoneNumber: item.phone_number,
          stripeId: item.stripe_id,
          title: item.title,
          verified: item.verified ? true : false,
          vaccination: item.vaccination ? true : false,
          status: item.status ? item.status : null,
        });
      });
      this.rowData = consultantArray;
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.index;
      this.dd.el = el;
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    addConsultant: function () {
      this.propsData = {
        type: constant.PANEL_TYPES.ADD,
      };
      this.addConsultantSubmitLoading = false;
      this.openEditPannel(1, "Add Consultant", true);
    },
    editConsultant: function (data) {
      this.hideCurrentAgDropdown();
      this.propsData = {
        ...data,
        type: constant.PANEL_TYPES.EDIT,
      };
      this.addConsultantSubmitLoading = false;
      this.openEditPannel(2, "Edit Consultant", false);
    },
    uploadResume: function (data) {
      this.hideCurrentAgDropdown();
      if (data.id) {
        this.uploadProps = data.id;
        this.openEditPannel(3, "Upload Resume", false);
      }
    },
    deleteConsultant: function (data) {
      this.hideCurrentAgDropdown();
      utils.deleteConfirm(() => {
        db.collection("consultants")
          .doc(data.id)
          .delete()
          .then(() => {
            this.$toasted.global.toast_success({ message: "delete success" });
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          });
      });
    },
    pannelButtonClick: function (data) {
      this.addConsultantSubmitLoading = true;
      // console.log(data)
      if (data.type == constant.PANEL_TYPES.ADD) {
        httpGet("add_consultant", {
          email: data.email.trim().toLowerCase(),
          name: data.name,
          bio: data.bio,
          metro: data.metro,
          applicationStatus: data.applicationStatus,
          techLevel: data.techLevel,
          password: data.password,
          sendEmail: data.sendEmail,
          rate: data.rate,
          isActive: data.isActive ? true : false,
          rateType: data.rateType,
          phoneNumber: data.phoneNumber,
          title: data.title,
          address: data.address,
          stripeId: data.stripeId,
        }).then((response) => {
          if (response.ok) {
            this.closeEditPannel();
            this.$toasted.global.toast_success({
              message: "add consultant success",
            });
          } else {
            this.$toasted.global.toast_error({ message: response.message });
          }
          this.addConsultantSubmitLoading = false;
        });
      } else if (data.type == constant.PANEL_TYPES.EDIT) {
        db.collection("consultants")
          .doc(data.id)
          .update({
            email: data.email ? data.email.trim().toLowerCase() : null,
            name: data.name ? data.name : null,
            bio: data.bio ? data.bio : null,
            metro: data.metro ? data.metro : null,
            work_type: data.workType ? data.workType : null,
            status: data.status ? data.status : null,
            application_status: data.applicationStatus
              ? data.applicationStatus
              : null,
            tech_level: data.techLevel ? data.techLevel : null,
            is_active: data.isActive ? true : false,
            rate: data.rate ? data.rate : null,
            rate_type: data.rateType ? data.rateType : null,
            phone_number: data.phoneNumber ? data.phoneNumber : null,
            title: data.title ? data.title : null,
            address: data.address ? data.address : null,
            stripe_id: data.stripeId ? data.stripeId : null,
            verified: data.verified ? true : false,
            vaccination: data.vaccination ? true : false,
          })
          .then((response) => {})
          .then(() => {
            this.closeEditPannel();
            this.$toasted.global.toast_success({
              message: "edit consultant success",
            });
            this.addConsultantSubmitLoading = false;
          })
          .catch((error) => {
            this.$toasted.global.toast_error({
              message: "edit consultant error",
            });
            this.addConsultantSubmitLoading = false;
          });
      }
    },
    resetFilter: function () {
      this.enableSetLocal = true;
      this.gridOptions.api.setFilterModel(null);
    },
  },
};
</script>
